import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const languages = ['en', 'zh-Hant', 'zh-Hans']; // Add your supported language codes here

  const getLanguageName = (code) => {
    return new Intl.DisplayNames([code], { type: 'language' }).of(code);
  };

  const currentLanguage = i18n.language;
  console.log(currentLanguage);

  const langOption = (code) => {
    if (code === i18n.language) {
      return <option value={code} selected>{getLanguageName(code)}</option>;
    } else {
      return <option value={code}>{getLanguageName(code)}</option>;
    }
  }

  return (
    <select className="form-select" style={{width: "150px"}} onChange={handleChange} value={i18n.language}>
      {languages.map((lng) => langOption(lng))}
      {/* <option value="en">English</option>
      <option value="zh-tw">繁體中文</option> */}
      {/* Add more options as needed */}
    </select>
  );
}


export default LanguageSwitcher;
